function CurrencyDisplay({ value, size = 'md', suffix = '' }) {
  const formatted = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(value || 0);

  const sizeClasses = {
    sm: 'text-lg font-bold',
    md: 'text-2xl font-bold',
    lg: 'text-4xl font-bold',
    xl: 'text-5xl font-bold',
  };

  return (
    <span className={`${sizeClasses[size] || sizeClasses.md} text-navy`}>
      {formatted}
      {suffix && <span className="text-sm font-normal text-gray-500 ml-1">{suffix}</span>}
    </span>
  );
}

export default CurrencyDisplay;
